import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import { Button } from '@/Components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/Components/ui/card';
import { CheckCircle, LogIn } from 'lucide-react';
import SEO from '../Components/SEO.jsx';

export default function EmailVerified() {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center px-4 pt-20">
            <SEO
                title="Email Verificata | Tecnosys"
                description="La tua email è stata verificata con successo."
            />

            <Card className="w-full max-w-md text-center">
                <CardHeader className="space-y-4">
                    <div className="w-20 h-20 mx-auto rounded-full bg-green-100 flex items-center justify-center mb-2">
                        <CheckCircle className="w-10 h-10 text-green-600" />
                    </div>
                    <CardTitle className="text-2xl text-green-700">Email Verificata!</CardTitle>
                </CardHeader>
                <CardContent className="space-y-8">
                    <p className="text-gray-600">
                        Il tuo indirizzo email è stato confermato con successo.
                        Ora puoi accedere alla tua Area Clienti.
                    </p>

                    <Link to={createPageUrl('Login')}>
                        <Button className="w-full rounded-full bg-blue-600 hover:bg-blue-700 text-white gap-2">
                            <LogIn className="w-4 h-4" />
                            Vai al Login
                        </Button>
                    </Link>
                </CardContent>
            </Card>
        </div>
    );
}
